const { addhttp } = require('./utils');

export const redirectToAppIfIsCoachDomain = (domain, path = '', params = '') => {
  const query = params ? `?${params}` : '';
  const redirectURL = addhttp(`${domain}${path}${query}`);
  console.info('redirectURL:', domain, path, redirectURL);
  window.location.href = redirectURL;
};
